<template>

  <div class="cp">

    <q-input outlined  :label="myLabel"  readonly  v-if="myModelValue==null" @click="toggle" class="cp">
        <template v-slot:append>
          <q-icon name="search" @click="toggle" class="cp"/>
        </template>
      </q-input>

    <q-input style="cursor:pointer" outlined v-model="myModelValue.name" :label="myLabel"  readonly  v-if="myModelValue!==null" @click="toggle">
        <template v-slot:append>
          <q-icon name="edit" class="cp" @click="toggle" />
          <q-icon name="search" class="cp" @click="openPromoter" />
        </template>
      </q-input>



    <!-- <q-input outlined @click="showPopup = !showPopup" disable v-model="myModelValue.name" /> -->

    <q-dialog
      v-model="showPopup"

      transition-show="fade"
      transition-hide="fade"
      class="scroll"
    >
      <q-card style="width:5000px">
        <q-card-section>
          <div class="text-h6">{{ myLabel }}</div>

          <q-input outlined  v-model="plz" label="PLZ" />
          <q-input outlined  v-model="filterString" label="Promotersuche" ref="mysearch" />
          <q-btn label="Promoter suchen" color="red" @click="reload"/>
        </q-card-section>
        <q-separator />
        <!-- <q-card-section class="q-pt-none"> -->
          <q-card-section style="height: 60vh;" class="scroll">
          <q-virtual-scroll
            type="table"
            style="max-height: 6d0vh"
            :virtual-scroll-item-size="48"
            :virtual-scroll-sticky-size-start="48"
            :virtual-scroll-sticky-size-end="32"
            :items="tabledataComputed"
          >
            <template v-slot:before>
              <thead class="thead-sticky text-left">
                <tr>
                  <th>#</th>
                  <th>Vorname</th>
                  <th>Nachname</th>
                  <!-- <th>E-Mail</th> -->
                  <th>PLZ</th>
                  <th>Ort</th>
                </tr>
              </thead>
            </template>

            <template v-slot="{ item: row, index }">
              <tr :key="index" @click="rowClicked(row, index)" class="cp">
                <td>{{ index + 1 }}</td>
                <td>{{ row.stammdaten.vorname }}</td>
                <td>{{ row.stammdaten.nachname }}</td>
                <!-- <td>{{ row.stammdaten.email }}</td> -->
                <td>{{ row.stammdaten.plz }}</td>
                <td>{{ row.stammdaten.ort }}</td>
              </tr>
            </template>
          </q-virtual-scroll>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Abbrechen" color="primary" v-close-popup />
          <!-- <q-btn flat label="Accept" color="primary" v-close-popup /> -->
        </q-card-actions>

        <q-card-actions align="left">
          <q-btn icon="delete" @click="entfernen"></q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script setup>
import { ref, watch, inject, computed } from 'vue';
import { useRouter } from 'vue-router';

  const props = defineProps( {
    id_promotion: String,
    promotion: Object,
    modelValue: Object,
    label: String,
    options: [],
  })
  const emit = defineEmits( ['update:modelValue'])

    const myModelValue = ref(props.modelValue);
    const myLabel = ref(props.label);
    let showPopup = ref(false);
    let filterString = ref('');
    let tabledata = ref([]);
    let mysearch = ref(null);
    let plz = ref(null);
    let router = useRouter()
    const web = inject('web');

    // let currentPromotion=storage.get("currentPromotion")


    let myTimeout=null
    watch(
      () => filterString.value,
      (newVal) => {

        if(myTimeout!==null){
          clearTimeout(myTimeout)
        }
        myTimeout = setTimeout(function(){
          reload()
        },250)
      console.log(newVal)

    }
    );

    // function update() {
    //   emit('update:modelValue', myModelValue.value);
    // }
     async function reload() {
        console.log("props.promotion")
        console.log(props.promotion)
        let params={
          searchText: filterString.value,
          plz: plz.value
        }
        if(props.id_promotion){
          params.id_promotion=props.id_promotion
        }

        // if(currentPromotion!=null){
        //   params.id_promotion=currentPromotion._id
        //   params.skipNichtFreigegebene=true
        // }
        let data = await web.post('/promoters', params);
        console.log('sdddd', data);
        tabledata.value = data.promoters;
    }

    function rowClicked(row) {
      console.log('row', row);

      myModelValue.value = {
        name: row.stammdaten.vorname + ' ' + row.stammdaten.nachname,
        id_user: row._id,
      };

      // myModelValue.value.name=personObject.name
      emit('update:modelValue', myModelValue.value);
      showPopup.value = false;
    }

    function entfernen(){
      if(!confirm("Sicher?")) return;
      myModelValue.value=null
      emit('update:modelValue', null);
      showPopup.value = false;
    }

    let tabledataComputed = computed(() => {
      return tabledata.value.filter((row) => {
        var regex = new RegExp(filterString.value, 'gi');
        let longString = row.stammdaten.vorname+" "+row.stammdaten.nachname;
        return longString.match(regex);
      });
    });


    // function focusRef(){
    //   console.log("focusref")
    //   myinput.value.focus()
    //   // console.log(myinput.value)
    // }

    function toggle() {
      console.log('mysearch',mysearch)
      showPopup.value = !showPopup.value

      if(showPopup.value){

        setTimeout(() => {
          mysearch.value.focus()
        },200)
      }
    }

function openPromoter(){

  console.log("myModelValue")
  console.log(myModelValue.value.id_user)
  router.push("/promoter/"+myModelValue.value.id_user)

}



</script>
